import { render, staticRenderFns } from "./AnnouncementIndex.vue?vue&type=template&id=9b4dd0ce&scoped=true"
import script from "./AnnouncementIndex.vue?vue&type=script&lang=js"
export * from "./AnnouncementIndex.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementIndex.vue?vue&type=style&index=0&id=9b4dd0ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b4dd0ce",
  null
  
)

export default component.exports